import { FC } from 'react';
import styles from './gridloader.module.sass';

// Pure-CSS 2×2 grid of 8px squares; each pulses in turn, a quarter-cycle
// apart, so the light travels around the grid.
export interface GridLoaderProps {
  /** Accessible label announced to screen readers. */
  label?: string;
  className?: string;
}

export const GridLoader: FC<GridLoaderProps> = ({ label = 'Loading', className }) => (
  <span className={`${styles.grid} ${className ?? ''}`} role="status" aria-label={label}>
    <i /><i /><i /><i />
  </span>
);

GridLoader.displayName = 'GridLoader';
export default GridLoader;
